import styled from "styled-components";

export const StyledHeader = styled.header`
  padding: 20px;
  margin: 10px 0;
`;
